import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { BoxIcon } from 'lucide-react';
interface ServiceFlipCardProps {
  title: string;
  description: string;
  highlightedText: string;
  activities: string[];
  deliverables: string[];
  icon: BoxIcon;
}
export function ServiceFlipCard({
  title,
  description,
  highlightedText,
  activities,
  deliverables,
  icon: Icon
}: ServiceFlipCardProps) {
  const [isFlipped, setIsFlipped] = useState(false);
  return <motion.div className="h-[360px] md:h-[420px] lg:h-[480px] perspective-1000 cursor-pointer" onHoverStart={() => setIsFlipped(true)} onHoverEnd={() => setIsFlipped(false)} data-id="element-203">
      <motion.div className="relative w-full h-full" animate={{
      rotateY: isFlipped ? 180 : 0
    }} transition={{
      duration: 0.6,
      ease: [0.4, 0, 0.2, 1]
    }} style={{
      transformStyle: 'preserve-3d'
    }} data-id="element-204">
        {/* Front of card */}
        <div className="absolute inset-0 p-8 md:p-10 lg:p-10 rounded-2xl bg-slate-50 border border-slate-100 flex flex-col items-center justify-center text-center overflow-hidden" style={{
        backfaceVisibility: 'hidden'
      }} data-id="element-205">
          <div className="w-12 h-12 min-w-[3rem] min-h-[3rem] rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0 mb-5" data-id="element-206">
            <Icon className="text-blue-600 flex-shrink-0" size={24} data-id="element-207" />
          </div>
          <h3 className="text-lg lg:text-xl font-medium text-slate-900 mb-3 flex-shrink-0" data-id="element-208">
            {title}
          </h3>
          <p className="text-sm lg:text-base text-slate-600 font-light leading-relaxed" data-id="element-209">
            {description.split(highlightedText)[0]}
            <span className="text-blue-500 font-normal" data-id="element-210">{highlightedText}</span>
            {description.split(highlightedText)[1]}
          </p>
        </div>

        {/* Back of card */}
        <div className="absolute inset-0 p-8 md:p-10 lg:p-10 rounded-2xl bg-slate-900 border border-slate-800 flex flex-col overflow-y-auto" style={{
        backfaceVisibility: 'hidden',
        transform: 'rotateY(180deg)'
      }} data-id="element-211">
          <div className="space-y-5" data-id="element-212">
            <div data-id="element-213">
              <h4 className="text-sm font-medium text-white mb-3" data-id="element-214">
                Activities
              </h4>
              <ul className="space-y-2 text-sm text-slate-300" data-id="element-215">
                {activities.map((activity, index) => <li key={index} className="flex items-start gap-2" data-id="element-216">
                    <div className="w-1.5 h-1.5 rounded-full bg-blue-400 mt-1.5 flex-shrink-0" data-id="element-217" />
                    <span data-id="element-218">{activity}</span>
                  </li>)}
              </ul>
            </div>
            <div data-id="element-219">
              <h4 className="text-sm font-medium text-white mb-3" data-id="element-220">
                Deliverables
              </h4>
              <ul className="space-y-2 text-sm text-slate-300" data-id="element-221">
                {deliverables.map((deliverable, index) => <li key={index} className="flex items-start gap-2" data-id="element-222">
                    <div className="w-1.5 h-1.5 rounded-full bg-blue-400 mt-1.5 flex-shrink-0" data-id="element-223" />
                    <span data-id="element-224">{deliverable}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </motion.div>
    </motion.div>;
}